export const HEADER_2_CONSTANTS = {
    DEFAULT_ROW: {
        id: "1",
        status: false,
        background_color: "#ffffff",
        logo: "",
        logo_alt_text: "",
    },

    HEADER_FIELDS_CONFIG: [
        {
            fieldName: "status",
            label: "Header Status",
            value: false,
            valueType: "boolean",
            filedType: "TOGGLE",
            placeholder: "Enter Header Status",
        },
        {
            fieldName: "background_color",
            label: "Container Base Background Color",
            value: "#ffffff",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter background color (e.g., #ffffff)",
        },
        {
            fieldName: "logo",
            label: "Logo",
            value: "",
            valueType: "string",
            filedType: "FILE",
            placeholder: "Upload Logo",
        },
        {
            fieldName: "logo_alt_text",
            label: "Logo Alt Text",
            value: "",
            valueType: "string",
            filedType: "INPUT",
            placeholder: "Enter logo alt text",
        },
    ],
}

